import { useState, useCallback, useMemo } from 'react';
import designationData from '../constants/designations.json';

export type TimePeriod = '1 Day' | '7 Days' | '30 Days' | '3 Months' | 'Custom';

export interface ReportFilters {
    timePeriod: TimePeriod;
    startDate: string | null;
    endDate: string | null;
    designations: string[];
}

export const useReportFilters = () => {
    const [filters, setFilters] = useState<ReportFilters>({
        timePeriod: '7 Days',
        startDate: null,
        endDate: null,
        designations: [],
    });

    const designations = useMemo(() => designationData.designations, []);

    const updateFilter = useCallback((key: keyof ReportFilters, value: any) => {
        setFilters(prev => ({ ...prev, [key]: value }));
    }, []);

    const resetFilters = useCallback(() => {
        setFilters({
            timePeriod: '7 Days',
            startDate: null,
            endDate: null,
            designations: [],
        });
    }, []);

    const isFilterActive = useMemo(() => {
        return filters.designations.length > 0 || filters.timePeriod !== '7 Days';
    }, [filters]);

    return {
        filters,
        updateFilter,
        resetFilters,
        designations,
        isLoadingDesignations: false,
        designationError: null,
        refetchDesignations: () => {},
        isFilterActive,
    };
};
